import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MapControls } from '../utilities/MapControls/MapConrols';
import { DirectionsService } from '../utilities/DirectionsService/DirectionsService';
import { Trip } from '../DataStructures/Trip/Trip';
import { Area } from '../DataStructures/Area/Area';
import { Destination } from '../DataStructures/Destination/Destination';
import { MatDialog } from '@angular/material';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import * as moment from 'moment';
import { UserService } from '../services/user-service/user.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MainService } from '../services/optimizer-service/optimizer.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationData } from '../shared/location-picker/location-picker.component';
import { CompanyService } from '../services/company-service/company.service';
import { FormUtils } from '../utilities/FormUtils/FormUtils';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { environment } from '../../environments/environment';

declare var google: any;
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})

export class RegisterComponent implements OnInit, AfterViewInit {



  @ViewChild('map') mapReference: ElementRef;
  @ViewChild('panel') panel;
  @ViewChild('basicInfoNextButton') basicInfoNextButton;
  @ViewChild('companySearch') companySearch: ElementRef;
  @ViewChild('emailField') emailField: ElementRef;
  uid
  gSignIn;
  registration = false;
  sub;
  pic;
  employeeid;
  search;
  locationData;
  companies = [
  ];
  filteredCompanies = [];
  userPopulated = false;
  jaLat = 18.1350138;
  jaLng = -77.1981928;
  emailTaken = false;
  navOptions = NavBarComponent.standard;
  lookupForm: FormGroup;
  infoForm: FormGroup;
  companyid = null;

  checked = [
    ['Sunday', false],
    ['Monday', false],
    ['Tuesday', false],
    ['Wednesday', false],
    ['Thursday', false],
    ['Friday', false],
    ['Saturday', false]
  ]
  firstnameInvalid = null;
  lastnameInvalid = null;
  emailInvalid = null;
  passwordInvalid = null;
  companyInvalid = null;
  employeeidInvalid = null;
  firstRun = true;


  //LOCATION INFO
  zonedAddress: string = "";
  typedAddress: string;
  addressErr = null;


  //PICK UP TIME INFO
  days = [
    ['Sunday', null],
    ['Monday', null],
    ['Tuesday', null],
    ['Wednesday', null],
    ['Thursday', null],
    ['Friday', null],
    ['Saturday', null]
  ];

  locationMsg: string;
  retrievedUser: any = null;
  autocomplete;
  mapOptions = null;
  Height;
  Width;
  locAddress;


  constructor(
    public mapControls: MapControls,
    private directionsService:DirectionsService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private companyService: CompanyService,
    private userService: UserService) {

    this.Height = (window.screen.height);
    this.Width = (window.screen.width);

    this.lookupForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    })
    this.infoForm = this.formBuilder.group({
      firstname: [null, [Validators.required]],
      lastname: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      company: [null],
      companyid: [null, Validators.required],
      employeeid: [null, Validators.required],
      finalAddress: [null, [Validators.required]],
      lat: [null, [Validators.required]],
      lng: [null, [Validators.required]],
      password: [null, [Validators.required]],
      confirmpassword: [null, [Validators.required]],
      terms: [false, Validators.required]
    })
  }

  getAddressText() {
    if (!this.infoForm.getRawValue().finalAddress) {
      return 'Setup Address'
    } else {
      return 'Change Address'
    }
  }

  continue() {
    if (this.lookupForm.valid) {
      this.userService.getUserByEmail(this.lookupForm.getRawValue().email).then((result) => {
        if (result.status) {
          sessionStorage.setItem('userData', JSON.stringify(result));
          this.populateUser(result);
          window.location.reload();
        }
      }).catch(e => {
        console.log(e);
        new QuickDialog(this.dialog).InfoDialog("Unable to fetch information, try again later", "Sorry", "OK");
      });
    } else {

    }
  }

  ngOnInit() {


    this.uid = this.route.snapshot.params.id;
    this.companyid = this.route.snapshot.queryParams.cid;
    this.gSignIn = this.route.snapshot.queryParams.gSignIn;
    this.sub = this.route.snapshot.queryParams.sub;
    this.pic = this.route.snapshot.queryParams.pic;
    this.employeeid = this.route.snapshot.queryParams.employeeid;
    if (this.gSignIn) {
      this.registration = true;
      this.makePasswordNotRequired();
      this.infoForm.patchValue({
        firstname: this.route.snapshot.queryParams.firstname,
        lastname: this.route.snapshot.queryParams.lastname,
        email: this.route.snapshot.queryParams.email,
        password: null,
        confirmpassword: null
      });
    }
    if (!this.uid && !this.gSignIn) {
      this.registration = true;
    }
    this.companyService.getCompanies().then((companies) => {
      this.companies = companies.data.filter(x => x.active);
      if(this.companyid){
        this.companies = this.companies.filter(x => x.id == this.companyid);
        var company = this.companies[0];
        this.infoForm.patchValue({
          companyid:company.id,
          company:company.company_name
        })
      }
      let userDataJson = sessionStorage.getItem('userData');
      if (userDataJson) {
        this.populateUser(JSON.parse(userDataJson));
      } else {
        if (this.uid) {
          this.userService.aukwhxbasuaksyaj(this.uid).then((xResult: any) => {

            if (xResult.status) {

              this.userService.isUserRegistered(xResult.data).then((isReg) => {

                if (isReg.status) {
                  var populate = sessionStorage.getItem('populate');
                  if (isReg.data) {
                    new QuickDialog(this.dialog).InfoDialog("You have already been registered", "Already Registered", "OK");
                    this.router.navigate(['/user/login']);
                  }
                  else if (!populate) {
                    this.userService.getUserByEmployeeId(xResult.data).then(result => {
                      if (result.status) {
                        this.populateUser(result);
                      } else {
                        new QuickDialog(this.dialog).InfoDialog("Something Went Wrong", "Sorry", "OK");
                      }
                    }).catch(e => {
                      new QuickDialog(this.dialog).InfoDialog("Something Went Wrong", "Sorry", "OK");
                    });
                  }
                } else {
                  new QuickDialog(this.dialog).InfoDialog("Something Went Wrong", "Sorry", "OK");
                }

              }).catch(e => {
                new QuickDialog(this.dialog).InfoDialog("Something Went Wrong", "Sorry", "OK");
              });

            } else {
              new QuickDialog(this.dialog).InfoDialog("Something Went Wrong", "Sorry", "OK");
            }

          }).catch(e => {
            new QuickDialog(this.dialog).InfoDialog("Something Went Wrong", "Sorry", "OK");
          });
        } else {

        }
      }
    });

  }

  makePasswordNotRequired() {
    let password = this.infoForm.get('password');
    password.clearValidators();
    password.updateValueAndValidity();
    let confirm = this.infoForm.get('confirmpassword')
    confirm.clearValidators();
    confirm.updateValueAndValidity();
  }

  populateUser(result) {
    this.infoForm.get('email').disable();
    this.infoForm.get('company').disable();
    if (!this.employeeid) {
      this.infoForm.get('employeeid').disable();
    }
    var populate = sessionStorage.getItem('populate');
    this.infoForm.patchValue({
      firstname: this.employeeid == '1' && !populate ? null : result.data.firstname,
      lastname: this.employeeid == '1' && !populate ? null : result.data.lastname,
      email: result.data.email,
      employeeid: this.employeeid == '1' && !populate ? null : result.data.employeeid,
      companyid: result.data.companyid,
      company: this.companies.find(c => c.id == result.data.companyid).company_name
    })

    this.retrievedUser = result.data;
    this.userPopulated = true;
  }

  openMap() {
    sessionStorage.setItem('pickingAddress', JSON.stringify({ 'picking': true }));
    sessionStorage.setItem('populate', 'true');
    sessionStorage.setItem('infoForm', JSON.stringify(this.infoForm.getRawValue()));
    this.router.navigate(['/picker']);
  }

  openTerms() {
    window.open(`${environment.SITE_URL}/terms-policy`, '_blank');
  }

  checkForInfoData() {
    let data = sessionStorage.getItem("infoForm");
    if (data) {
      let info = JSON.parse(data);
      this.infoForm.patchValue(info);
      sessionStorage.removeItem("infoForm");
    }
  }

  checkForAddressData() {
    if (sessionStorage.getItem('pickingAddress')) {
      this.emailField.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      sessionStorage.removeItem('pickingAddress')
    }
    let data = sessionStorage.getItem("locationdata");
    if (data) {
      let locationInfo = JSON.parse(data);

      this.infoForm.patchValue({
        finalAddress: locationInfo.address,
        lat: locationInfo.lat,
        lng: locationInfo.lng
      });

      this.zonedAddress = this.infoForm.getRawValue().finalAddress;
      this.typedAddress = this.infoForm.getRawValue().finalAddress;
      this.addressErr = null;
      sessionStorage.removeItem("locationdata");
    }
  }

  ngAfterViewInit(): void {
    this.initialize();
  }

  onCompanySearch(event) {
    if (!this.companySearch.nativeElement.value) {
      this.filteredCompanies = this.companies;
    } else {
      this.filteredCompanies = this.companies.filter(x =>
        (`${x.company_name}`.toLocaleLowerCase()).includes(this.companySearch.nativeElement.value.toLocaleLowerCase())
      );
    }
  }

  setCompanyId(id) {
    console.log(id);
    this.infoForm.patchValue({
      companyid: id
    });
  }

  initialize() {
    this.checkForInfoData();
    this.checkForAddressData();
    if (this.mapReference) {
      this.mapControls.initialize(this.mapReference);
      if (this.Width <= 820) {
        this.mapControls.createMapAndCenterOnLoaction(this.jaLat, this.jaLng, true);
      } else {
        this.mapControls.createMapAndCenterOnLoaction(this.jaLat, this.jaLng);
      }

      this.mapControls.map.setZoom(7);
      this.latLngOnClick()
      this.initAutoComplete();
      this.panel.open();
      this.showInfoDialog("Select your dropoff location by typing it in the " +
        "searchbox on the map or clicking on the map to drop a marker. You can use the mousewheel to zoom in and out", "Drop Off Location", "Got It!");
    }
  }


  clearTime(day) {
    this.days.find(x => x[0] == day)[1] = null;
  }



  getDisplayTime(time) {
    if (time == null) {
      return 'No Time Selected'
    } else {
      return moment('2018-01-01 ' + time + ':00').format('hh:mm A')
    }
  }


  locationNext() {

    var valid = true;
    let form = this.infoForm.getRawValue();
    this.addressErr = null;

    if (form.finalAddress == null || form.lat == null || form.lng == null) {
      this.addressErr = "";
      valid = false;
    }
    /*if(!valid){
      new QuickDialog(this.dialog).InfoDialog('You have not picked your address, please search for your address on the map and then click on the map to drop the pin at your precise drop-off location','Form Incomplete',"OK");
    }*/
    return valid;
  }
  mapNext() {
    if (!this.locationNext()) {
      new QuickDialog(this.dialog).InfoDialog('You have not picked your address, please open the map and search for your address on and then click on the map to drop the pin at your precise drop-off location', 'Select Your Address', "OK");
    } else {
      this.infoForm.patchValue({
        finalAddress: this.typedAddress
      })
    }
  }

  timeNext() {
    var valid = false;
    this.days.forEach(d => {

      if (d[1] != null) {

        valid = true;
      }
    })
    return valid;
  }

  initAutoComplete() {
    this.search = document.getElementById('search');
    this.mapControls.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.search);
    this.autocomplete = new google.maps.places.Autocomplete(this.search, this.getOptions());
    this.regAutoCompleteListener();
  }

  regAutoCompleteListener() {

    this.mapControls.registerAutcompleteListener('place_changed', this.autocomplete).then(place => {
      var loc = new LocationData("", place.geometry.location.lat(), place.geometry.location.lng());
      this.validateLocation(loc, true);
      this.regAutoCompleteListener();
    }).catch(e => {
      this.regAutoCompleteListener();
    })
  }

  getOptions() {
    var defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(17.546889258900055, -78.54058735825066),
      new google.maps.LatLng(18.591323377300697, -76.02471821762566)
    )
    return {
      bounds: defaultBounds
    };
  }

  getTestOrigins() {


    var destination = new Destination(18.0418764, -76.7772811, "", null);
    var destinations = new Array<Destination>();
    destinations.push(destination);
    return new Area(
      -1,
      "Russell Heights, Kingston, Jamaica",
      null,
      destinations,
      true
    );
  }

  latLngOnClick() {

    this.mapControls.registerListener('click').then(e => {
      this.latLngOnClick();
      var loc = new LocationData("", e.latLng.lat(), e.latLng.lng());
      this.validateLocation(loc, false);
    }).catch(e => {
      this.latLngOnClick();
    })
  }

  validateLocation(locationData: LocationData, fromSearch: boolean, prevAddress = null) {

    var dest = new Destination(locationData.lat, locationData.lng, "", null)
    var validTrip = new Trip(this.getTestOrigins(), new Area(1, "User Selected Location", null, [dest], false), [], null);
    var invalid = false;
    validTrip.getDirectionsGoogle(this.directionsService, null).then(res => {
      locationData.address = res.directions.routes[0].legs[0].end_address;
      locationData.lat = res.directions.routes[0].legs[0].end_location.lat();
      locationData.lng = res.directions.routes[0].legs[0].end_location.lng();
      locationData.id = locationData.id;
      this.locationValid(locationData, fromSearch, prevAddress);
    }).catch(e => {
      this.locationInvalid();
    })
  }


  locationValid(locationData: LocationData, fromSearch: boolean, prevAddress = null) {

    this.locAddress = this.decideLocAddress(prevAddress, locationData.address);
    locationData.address = this.locAddress;
    this.mapControls.addMarker(new google.maps.LatLng(locationData.lat, locationData.lng), "", true, 'register-marker.png').addListener('click', function () {
    });
    if (fromSearch) {
      this.mapControls.centerMapOnLoaction(new google.maps.LatLng(locationData.lat, locationData.lng));
    }
    this.locationData = locationData;
    this.infoForm.patchValue({
      finalAddress: locationData.address,
      lat: locationData.lat,
      lng: locationData.lng
    });
    this.typedAddress = this.infoForm.getRawValue().finalAddress;
  }

  private decideLocAddress(prevAddress = null, end_address) {
    return end_address;
  }

  showLocationPrompt(zone, parish, country) {

    new QuickDialog(this.dialog).PromptDialog({
      msg: "Where in " + parish + " are you located?",
      title: "Quick Question " + this.infoForm.getRawValue().firstname,
      cancelable: false,
      defaultValue: null,
      valueRequired: true,
      valueRequiredMsg: "Please provide this information to continue"
    }).then(answer => {
      if (answer.toString() == "true" || answer.toString().trim() == "" || answer.toString().length < 3) {

        new QuickDialog(this.dialog).InfoDialog("Please provide a valid area in " + parish + " to continue", "Sorry", "OK").then(() => {
          this.showLocationPrompt(zone, parish, country);
        })

      } else {
        this.zonedAddress = answer + this.uid + " " + parish + "," + country;
      }
    });
  }

  locationInvalid() {
    ;
    this.infoForm.patchValue({
      finalAddress: null,
      lat: null,
      lng: null
    })

    this.showInfoDialog("Location Not Allowed, Please select a location within Jamaica", "Invalid Location", "OK");
    let jaLat = 18.9350138;
    let jaLng = -77.7981928;

    this.mapControls.clearMarkers();
    this.search.value = null;
    this.mapControls.centerMapOnLoaction(new google.maps.LatLng(this.jaLat, this.jaLng));
    this.mapControls.map.setZoom(7);
  }

  clearValidationErrors() {
    this.firstnameInvalid = null;
    this.lastnameInvalid = null;
    this.emailInvalid = null;
    this.passwordInvalid = null;
  }

  basicInfoNext() {

    this.clearValidationErrors();
    if (this.firstRun == true) {
      this.firstRun = false;
      return false;
    }

    var valid = true;
    let form = this.infoForm.getRawValue();
    valid = this.infoForm.valid;

    if (!this.gSignIn) {
      if (form.password != null) {
        if (form.password.length < 6) {
          this.passwordInvalid = "Password must be 6 or more characters";
          valid = false;
        }
        else if (form.password != form.confirmpassword) {
          this.passwordInvalid = "Password and confirm password fields must match";
          valid = false;
        }
      } else {
        this.passwordInvalid = "Please enter a password";
        valid = false;
      }
    }
    if (this.employeeidInvalid) {
      valid = false;
    }
    if (this.emailInvalid) {
      valid = false;
    }

    return valid;
  }

  validateEmail() {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(this.infoForm.getRawValue().email).toLowerCase());
  }

  checkEmployeeidTaken() {
    if (this.uid) {
      this.employeeidInvalid = null;
      return;
    }
    let form = this.infoForm.getRawValue();
    this.companyService.getEmployeeid(form.companyid, form.employeeid).then((res) => {
      if (res.status) {
        if (res.data) {
          if (res.data.length > 0) {
            this.employeeidInvalid = "That employeeid is in use, if this is your employee number contact support@tomertransport.com to have the issue resolved."
          } else {
            this.employeeidInvalid = null;
          }
        }
      }
    });
  }

  checkEmailTaken(): Promise<boolean> {

    //this.basicInfoNextButton.disabled = true;
    return new Promise((resolve, reject) => {
      if (this.uid) {
        resolve(false);
        return;
      }

      this.userService.checkEmailExist(this.infoForm.getRawValue().email).then((res: any) => {

        if (res.status) {
          if (res.data) {
            this.emailTaken = true;
            resolve(true);
          } else {
            this.emailTaken = false;
            //this.basicInfoNextButton.disabled = false;
            resolve(false);
          }
        } else {
          //this.basicInfoNextButton.disabled = false;
          reject(res.message);
        }

      }).catch(e => {
        console.log(e);
        try{
          if(e.status){
            var body = JSON.parse(e._body);
            new QuickDialog(this.dialog).InfoDialog(body.message,"","OK");
          }
        }catch(ex){
          reject(ex);
        }
        reject(e);
      })
    })

  }

  async registerUser() {
    FormUtils.markFormGroupTouched(this.infoForm);
    await this.checkEmailTaken();
    await this.checkEmployeeidTaken();
    if (!this.basicInfoNext() || !this.infoForm.get('terms').value) {
      new QuickDialog(this.dialog).InfoDialog('Please fill out all field and tick the checkbox to accept the terms & privacy policy', 'Form Incomplete', "OK");
      return;
    }

    let form = this.infoForm.getRawValue();
    var user = {
      "sub": this.sub,
      "pic": this.pic,
      "employeeid": this.retrievedUser && !this.employeeid ? this.retrievedUser.employeeid : form.employeeid,
      "companyid": form.companyid,
      "firstname": form.firstname,
      "lastname": form.lastname,
      "email": form.email,
      "address": form.finalAddress,
      "pickup_address": form.finalAddress,
      "lat": form.lat,
      "lng": form.lng,
      "password": form.password,
      "days": this.days
    }

    if (this.registration) {
      let d = new QuickDialog(this.dialog).LoadingDialog("Creating Account...");
      this.userService.createUser(user).then((res: any) => {
        d.close();
        if (res.status) {
          window.location.href = `${environment.SITE_URL}/registration-complete?email=${form.email}`;
        } else {
          this.showInfoDialog(res.message, "Error, Please Try Again", "OK");
        }
      }).catch(e => {
        d.close();
        this.showInfoDialog("We weren't able to register you. Please try again in a few minutes", "Registration Failed", "OK");
      });
    } else {
      this.userService.completeRegistration(user).then((res: any) => {
        if (res.status) {
          this.showInfoDialog("Registration Successful", "All Set", "Go To Account").then(() => {
            this.router.navigate(['user/login']);
          }).catch(e => {
            this.router.navigate(['user/login']);
          })

        } else {
          this.showInfoDialog(res.message, "Error, Please Try Again", "OK");
        }
      }).catch(e => {

        this.showInfoDialog(e, "Unexpected Error", "OK");
      })
    }
  }

  showInfoDialog(message: string, title: string, closemsg: string): Promise<any> {

    return new Promise((resolve, reject) => {
      new QuickDialog(this.dialog).InfoDialog(message, title, closemsg).then(() => {

        resolve(null);
      }).catch(e => {
        reject(e);
      });
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts